<div style="background-color: white; height: calc(100% - 100px);">     
    <div *ngIf="isLoading" class="loading-shade">
        <mat-spinner></mat-spinner>
    </div> 
    <div style="display: flex; flex-direction: row; justify-content: space-between; gap: 1em; padding: 1em;">								
        <div style="width: 100%;">            
                <span>Primary [{{dataSourcePrimaryBA?.filteredData.length}}]</span>
                <table mat-table [dataSource]="dataSourcePrimaryBA" *ngIf="!isLoading" class="mat-elevation-z8">
                    <!-- Name Column -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Name </th>
                        <td mat-cell *matCellDef="let element"><a target="_self"
                                [routerLink]="['/applications/summary', element.id]"
                                [queryParams]="{ dealname: element.Deal_Name }">{{element.Deal_Name}}</a>  </td>
                    </ng-container>

                    <!-- Province Column -->
                    <ng-container matColumnDef="province">
                        <th mat-header-cell *matHeaderCellDef> Province </th>
                        <td mat-cell *matCellDef="let element"> {{element.Province}} </td>
                    </ng-container>

                    <!-- Province Column -->
                    <ng-container matColumnDef="agencyName">
                        <th mat-header-cell *matHeaderCellDef> Agency </th>
                        <td mat-cell *matCellDef="let element"> {{element.Agency_Formula}} </td>
                    </ng-container>

                    <!-- <ng-container matColumnDef="drive">
                        <th mat-header-cell *matHeaderCellDef> Drive </th>
                        <td mat-cell *matCellDef="let element">
                            <a class="noline" target="_self" href="{{ element.gdriveextension__Drive_URL }}"> Open </a> 
                        </td>
                    </ng-container> -->                    

                    <!-- Modified Note Column -->
                    <ng-container matColumnDef="note">
                        <th mat-header-cell *matHeaderCellDef> Most Recent Note </th>
                        <td mat-cell *matCellDef="let element"> {{element.Reason_for_Poor_credit_score}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="baColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: baColumns;" class="element-row"></tr>
                </table>	
                <mat-paginator #paginatorPrimary [length]="1000" [pageSize]="10"></mat-paginator>  
        </div>	
        <div style="width: 100%;">
            <span>Co-Applicant [{{dataSourceCoAppBA?.filteredData.length}}]</span>
            <table mat-table [dataSource]="dataSourceCoAppBA" *ngIf="!isLoading" class="mat-elevation-z8">
                <!-- Name Column -->
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> Name </th>
                    <td mat-cell *matCellDef="let element"><a target="_self"
                            [routerLink]="['/applications/summary', element.id]"
                            [queryParams]="{ dealname: element.Deal_Name }">{{element.Deal_Name}}</a>  </td>
                </ng-container>

                <!-- Province Column -->
                <ng-container matColumnDef="province">
                    <th mat-header-cell *matHeaderCellDef> Province </th>
                    <td mat-cell *matCellDef="let element"> {{element.Province}} </td>
                </ng-container>

                <!-- Province Column -->
                <ng-container matColumnDef="agencyName">
                    <th mat-header-cell *matHeaderCellDef> Agency </th>
                    <td mat-cell *matCellDef="let element"> {{element.Agency_Formula}} </td>
                </ng-container>

                <!-- Modified Note Column -->
                <ng-container matColumnDef="note">
                    <th mat-header-cell *matHeaderCellDef> Most Recent Note </th>
                    <td mat-cell *matCellDef="let element"> {{element.Reason_for_Poor_credit_score}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="baColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: baColumns;" class="element-row"></tr>
            </table>
            <mat-paginator #paginatorCoApp [length]="1000" [pageSize]="10"></mat-paginator>
        </div>	
    </div>
</div>
